/**
 * Compare product picker a11y (incremental; does not replace compare-index.js).
 * Keyboard + aria-expanded; selection/compare logic stays in compare-index.js.
 */
(function () {
  'use strict';

  var ROOT_SEL = '.as-compare-model, .as-compare-model-cordless';
  var WRAP_SEL = '.as-dropdown-wrap';
  var TRIGGER_SEL = '.product-selected.as-dropdown';
  var PANEL_SEL = '.as-dropdown-target';
  var OPTION_SEL = '.as-product-select-list';

  function isOpen(panel) {
    return panel.classList.contains('is-active');
  }

  function syncExpanded(trigger, panel) {
    trigger.setAttribute('aria-expanded', isOpen(panel) ? 'true' : 'false');
  }

  function getOptions(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll(OPTION_SEL));
  }

  function syncOptions(panel) {
    getOptions(panel).forEach(function (opt) {
      opt.setAttribute('role', 'option');
      opt.setAttribute('tabindex', '-1');
      opt.setAttribute(
        'aria-selected',
        opt.classList.contains('product-selected-list') ? 'true' : 'false'
      );
    });
  }

  function focusFirstOption(panel) {
    var opts = getOptions(panel);
    if (!opts.length) return;
    requestAnimationFrame(function () {
      opts[0].focus();
    });
  }

  function closeAllDropdowns(root) {
    root.querySelectorAll(PANEL_SEL + '.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    root.querySelectorAll(TRIGGER_SEL + '.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    root.querySelectorAll(TRIGGER_SEL).forEach(function (tr) {
      tr.setAttribute('aria-expanded', 'false');
    });
  }

  function enhanceWrap(wrap, index, root) {
    var trigger = wrap.querySelector(TRIGGER_SEL);
    var panel = wrap.querySelector(PANEL_SEL);
    if (!trigger || !panel) return;

    if (!trigger.id) {
      trigger.id = 'compare-product-picker-trigger-' + index;
    }
    if (!panel.id) {
      panel.id = 'compare-product-picker-list-' + index;
    }
    if (!trigger.getAttribute('aria-controls')) {
      trigger.setAttribute('aria-controls', panel.id);
    }
    if (!trigger.hasAttribute('aria-haspopup')) {
      trigger.setAttribute('aria-haspopup', 'listbox');
    }
    if (!panel.hasAttribute('role')) {
      panel.setAttribute('role', 'listbox');
    }

    trigger.setAttribute('tabindex', '0');
    syncExpanded(trigger, panel);
    syncOptions(panel);

    var mo = new MutationObserver(function () {
      syncExpanded(trigger, panel);
      syncOptions(panel);
    });
    mo.observe(panel, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
      childList: true,
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var wasOpen = isOpen(panel);
        trigger.click();
        if (!wasOpen && isOpen(panel)) {
          focusFirstOption(panel);
        }
        return;
      }
      if (e.key === 'ArrowDown' && !isOpen(panel)) {
        e.preventDefault();
        trigger.click();
        focusFirstOption(panel);
      }
    });

    panel.addEventListener('keydown', function (e) {
      var options = getOptions(panel);
      if (!options.length) return;

      var current = document.activeElement;
      var idx = options.indexOf(current);

      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        closeAllDropdowns(root);
        trigger.focus();
        return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = idx < 0 ? 0 : (idx + 1) % options.length;
        options[next].focus();
        return;
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = idx < 0 ? options.length - 1 : (idx - 1 + options.length) % options.length;
        options[prev].focus();
        return;
      }

      if ((e.key === 'Enter' || e.key === ' ') && current && current.classList.contains('as-product-select-list')) {
        e.preventDefault();
        current.click();
        requestAnimationFrame(function () {
          trigger.focus();
        });
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll(ROOT_SEL);
    roots.forEach(function (root) {
      var wraps = root.querySelectorAll(WRAP_SEL);
      wraps.forEach(function (wrap, i) {
        enhanceWrap(wrap, i, root);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      roots.forEach(function (root) {
        if (!root.querySelector(PANEL_SEL + '.is-active')) return;
        var openTrigger = root.querySelector(TRIGGER_SEL + '[aria-expanded="true"]');
        closeAllDropdowns(root);
        if (openTrigger) openTrigger.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
